import React from "react";
import "../../assets/style/errorStyle.css"
import {ReactComponent as Notfound} from "../../assets/images/ullistrations/nf3.svg";
import {Link} from "react-router-dom";

const Erreur404=()=>{
    return(
        <div className="container-error">
            <Notfound/>
            <div>
                <Link to="/">Retournez à l'accueil</Link>
            </div>
        </div>
    )
}
export default Erreur404;